<template>
    <div class="card-box clear-both">
        <el-row >
            <el-col class="border-right" :span="8">
                <GoalItem @click-item="getGoalInfo" :cost-type="data.cost_type" :plat-id="data.plat_id" :goal="mainGoal" :is-active="data.active_item===mainGoal.scene_type" :is-risk="mainGoal.has_risk=='1'" />

                <div class="split-line mt10 mb10"></div>

                <GoalItem @click-item="getGoalInfo" :cost-type="data.cost_type" :plat-id="data.plat_id" v-for="goal in subGoals" :goal="goal" :key="goal.scene_type" :is-risk="goal.has_risk=='1'" is-sub-item :is-active="data.active_item===goal.scene_type"/>

            </el-col>
            <el-col :span="16">
                <div class="ml10 right-content">
                    <div class="risk-mark" v-if="sceneInfo.has_risk=='1'">
                        <el-tooltip class="item" effect="dark"placement="top">
                            <div slot="content">
                                <p v-html="detailData.risk_msg"></p>
                            </div>
                            <div class="inline-block">
                                <span>有风险</span>
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="right-top mt10">
                        <el-row >
                            <el-col class="border-right" :span="12">
                                <p class="mb8 nowrap">
                                    <span class="label-text label-text-wide">截止今日: 目标消耗</span>
                                    <span class="goal-text-val">{{sceneInfo.today_predict_cost}}</span>
                                </p>
                                <p class="nowrap">
                                    <span class="label-text label-text-wide">截止今日: 实际消耗</span>
                                    <span class="goal-text-val">{{sceneInfo.actual_cost}}</span>
                                </p>
                            </el-col>
                            <el-col class="" :span="12">
                                <p class="mb8 nowrap"><span class="label-text">偏差值: </span>{{sceneInfo.diff_cost}}</p>
                                <p class="nowrap">
                                    <span class="label-text">预估完成: </span>
                                    <span :class="[isPredictRisk?'text-color-error':'']">{{sceneInfo.predict_cost}}（{{sceneInfo.predict_rate}}）</span>
                                </p>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="right-bottom relative" v-loading="data.detailLoading">
                        <div class="full-chart-icon" @click="fullScreen">
                            <span class="icon iconfont icon-jt-quanping_o" title="全屏展示" ></span>
                        </div>
                        <div class="chart" :id="'kpiDetailChart-'+data.plat_id"></div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import GoalItem from './goalItem';
    export default {
        name: "GoalCard",
        components:{
            GoalItem,
        },
        props:{
            data:{
                type:Object,
                required:true,
            },
        },
        data(){
            return {
            }
        },
        computed:{
            mainGoal(){
                return this.data.cost_data.find(item=>item.scene_type=='1')||{};
            },
            subGoals(){
                return this.data.cost_data.filter(item=>item.scene_type!='1')||[];
            },
            detailData(){
                return this.data.detailData||{};
            },
            sceneInfo(){
                let activeItem = this.data.active_item;
                return this.data.cost_data.find(item=>item.scene_type==activeItem)||{};
            },
            isPredictRisk(){
                let predict_rate = this.sceneInfo.predict_rate||'';
                if(!predict_rate||predict_rate==='--') return false;
                return parseFloat(predict_rate)<100;
            }

        },
        methods:{
            getGoalInfo(val){
                this.$emit('change-active',this.data.plat_id,val);
            },
            fullScreen(){
                this.$emit('full',this.data.plat_id);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .card-box{
        /*background-color: #eee;*/
    }
    .border-right{
        border-right: solid 1px #d7d7d7;
    }

    .split-line{
        width: calc(100% - 10px);
        height: 0;
        border-bottom: dashed 1px #d7d7d7;
    }



    .right-content{
        .label-text{
            display: inline-block;
            white-space: nowrap;
            color: #7F7F7F;
            width: 65px;
            text-align: right;
            margin-right: 5px;
        }
        .label-text-wide{
            width: 106px;
        }

        .risk-mark{
            color: #fff;
            width: 100px;
            height: 26px;
            background-color: red;
            line-height: 26px;
            text-align: center;
            font-weight: bold;
            position: absolute;
            right: -40px;
            top: -3px;
            transform: rotate(45deg);
            cursor: pointer;
        }

        .right-bottom{
            height: 200px;
            margin-top: 10px;
            .chart{
                /*background-color: #eee;*/
                height: 100%;
            }
        }
    }

    .full-chart-icon{
        width: 30px;
        height: 30px;
        position: absolute;
        right: 0;
        top: 5px;
        cursor: pointer;
        z-index: 1;
    }

    .goal-text-val{
        display: inline-block;
        min-width: 36px;
        text-align: right;
    }

    @media only screen and (min-width: 1440px) {
        .right-content{
            .label-text{
                width: 75px!important;
            }
            .label-text-wide{
                width: 120px!important;
            }
        }

    }


</style>
